const PageApplication = require('../../modules/page/frontend/application.coffee');

import FlexibleHomeApplication from './frontend/application';

PageApplication.initialize();
FlexibleHomeApplication.initialize();
